(() => {
  if (window.BDSampleQuantity) return;
  const limit = 3;
  const root = window.Shopify?.routes?.root || '/';
  let pending = Promise.resolve();
  const message = () => window.theme?.strings?.sampleQuantityLimit || 'You can order up to 3 pieces of each sample online. Need more? Contact a flooring expert.';
  const sku = item => String(item.sku || '').trim().toUpperCase();
  const isSample = item => /-(S|L)$/.test(sku(item));
  const key = item => sku(item) || String(item.variant_id || item.id);
  function totals(items) {
    const result = new Map();
    items.filter(isSample).forEach(item => result.set(key(item), (result.get(key(item)) || 0) + Number(item.quantity)));
    return result;
  }
  function assertCart(cart) {
    if ([...totals(cart.items).values()].some(quantity => quantity > limit)) throw new Error(message());
  }
  async function readCart() {
    const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(window.theme?.strings?.cartError || 'Unable to check your cart. Please try again.');
    return response.json();
  }
  function enqueue(task) {
    const result = pending.then(task);
    pending = result.catch(() => {});
    return result;
  }
  function assertAdd(cart, items) {
    const counts = totals(cart.items);
    items.forEach(item => {
      const existing = cart.items.find(line => String(line.variant_id) === String(item.id));
      const itemKey = key(existing || item);
      const quantity = Number(item.quantity || 1);
      const current = counts.get(itemKey) || 0;
      if (current + quantity > limit) throw new Error(message());
      counts.set(itemKey, current + quantity);
    });
  }
  function add(items) {
    return enqueue(async () => {
      const cart = await readCart();
      assertAdd(cart, items);
      return fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items.map(({ sku: ignored, ...item }) => item) })
      });
    });
  }
  function change(url, options) {
    return enqueue(async () => {
      const body = JSON.parse(options.body);
      const cart = await readCart();
      const line = body.id ? cart.items.find(item => item.key === body.id) : cart.items[Number(body.line) - 1];
      if (line && isSample(line) && Number(body.quantity) > 0) {
        const other = (totals(cart.items).get(key(line)) || 0) - Number(line.quantity);
        if (other + Number(body.quantity) > limit && Number(body.quantity) >= Number(line.quantity)) throw new Error(message());
      }
      if (line) {
        body.id = line.key;
        delete body.line;
      }
      return fetch(url, { ...options, body: JSON.stringify(body) });
    });
  }
  function reductions(cart) {
    const remaining = new Map();
    const updates = {};
    cart.items.filter(isSample).forEach(item => {
      const left = remaining.has(key(item)) ? remaining.get(key(item)) : limit;
      const quantity = Math.min(Number(item.quantity), left);
      remaining.set(key(item), left - quantity);
      if (quantity !== Number(item.quantity)) updates[item.key] = quantity;
    });
    return updates;
  }
  function reduce() {
    return enqueue(async () => {
      const updates = reductions(await readCart());
      if (!Object.keys(updates).length) return;
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates })
      });
      if (!response.ok) throw new Error(window.theme?.strings?.cartError || 'Unable to update your cart. Please try again.');
    });
  }
  window.BDSampleQuantity = { limit, message, isSample, totals, assertCart, assertAdd, readCart, add, change, reduce, reductions };
})();
